import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/sso-callback')({
    head: () => ({ meta: [{ title: 'Sign in | promote.fun' }] }),
    component: () => <AuthenticateWithRedirectCallback />,
});
